import { ReactComponent as HomeIcon } from "../lib/icons/Home.svg";
import { ReactComponent as EnvelopeIcon } from "../lib/icons/Envelope.svg";
import { ReactComponent as PhoneIcon } from "../lib/icons/Phone.svg";

export const conInfo2 = [
  {
    conIcon: <HomeIcon className="h-[3.4375rem] fill-accent"></HomeIcon>,
    conTitle: "Los Angeles:",
    conCap: "60 East 65th Street NY 10065",
  },
  {
    conIcon: <PhoneIcon className="h-[3.4375rem] fill-accent"></PhoneIcon>,
    conTitle: "Phone:",
    conCap: "+29 (044) 593 85 63",
  },
  {
    conIcon: <EnvelopeIcon className="h-[3.4375rem] fill-accent"></EnvelopeIcon>,
    conTitle: "Email Address:",
    conCap: "info@youremail.com",
  },
];
